<template>
    <v-layout justify-center>
        <v-responsive max-width="1024px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span v-if="user._id">회원 상세보기</span>
                <span v-else>회원 등록</span>
            </div>

            <v-card class="my-4">
                <v-row no-gutters>
                    <v-col cols="12" md="8">
                        <v-card-subtitle class="font-weight-bold grey lighten-4">계정</v-card-subtitle>
                        <v-divider />
                        <v-row class="mx-1 my-4">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.username" label="아이디" persistent-placeholder hide-details readonly></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-if="user?._id" :value="user.createdAt?.toDateTime?.()" label="가입일시" persistent-placeholder hide-details readonly></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-1 my-4">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.password" label="비밀번호" persistent-placeholder hide-details></v-text-field>
                            </v-col>
                            <!-- <v-col cols="12" sm="6" class="py-0">
                                <v-select v-model="user.scope" :items="scope" label="권한" multiple persistent-placeholder hide-details></v-select>
                            </v-col> -->
                            <v-col cols="12" sm="6" class="py-0">
                                <!-- <v-text-field v-model="user.subPassword" label="서브비밀번호" persistent-placeholder hide-details></v-text-field> -->
                            </v-col>
                        </v-row>

                        <v-divider />
                        <v-card-subtitle class="font-weight-bold grey lighten-4">기본 정보</v-card-subtitle>
                        <v-divider />

                        <template v-if="user.type == PERSON.value">
                            <v-row class="mx-1 my-4">
                                <v-col cols="12" sm="6" class="py-0">
                                    <v-text-field v-model="user.name" label="이름" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" class="py-0">
                                    <v-text-field v-model="user.bornAt" type="date" max="2999-12-31" label="생년월일" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-1 my-4">
                                <v-col cols="12" sm="6" class="py-0">
                                    <v-text-field v-model="user.gender" label="성별" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-if="user.type == COMPANY.value">
                            <v-row class="mx-1 my-4">
                                <v-col cols="12" sm="6" class="py-0">
                                    <v-text-field v-model="user.name" label="기업명" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" class="py-0">
                                    <v-text-field v-model="user.ceoName" label="대표자명" persistent-placeholder hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mx-1 my-4">
                                <v-col cols="12" class="py-0">
                                    <v-text-field v-model="user.website" label="홈페이지주소" persistent-placeholder hide-details>
                                        <v-btn slot="append" small text icon :href="user.website" target="_blank"> <v-icon>mdi-link</v-icon> </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </template>

                        <v-divider />
                        <v-card-subtitle class="font-weight-bold grey lighten-4">연락처</v-card-subtitle>
                        <v-divider />
                        <v-row class="mx-1 my-4">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.phone" label="연락처" persistent-placeholder hide-details></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.email" label="이메일" persistent-placeholder hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-divider />
                        <v-row class="mx-1 my-4">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.postcode" label="우편번호" persistent-placeholder hide-details readonly @click="$refs.DaumPostcode.open()"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-1 my-4">
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.address1" label="기본주소" persistent-placeholder hide-details readonly @click="$refs.DaumPostcode.open()"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" class="py-0">
                                <v-text-field v-model="user.address2" label="상세주소" persistent-placeholder hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <daum-postcode ref="DaumPostcode" @input="setAddress" />
                    </v-col>
                    <v-col cols="auto">
                        <v-divider class="d-none d-md-block" vertical />
                        <v-divider class="d-block d-md-none" />
                    </v-col>
                    <v-col cols="12" md="">
                        <template v-if="user.type == COMPANY.value">
                            <v-card-subtitle class="font-weight-bold grey lighten-4">로고</v-card-subtitle>
                            <v-divider />
                            <image-input v-model="user.logo" contain flat tile :aspect-ratio="3 / 1" />
                            <v-divider />
                            <v-card-subtitle class="font-weight-bold grey lighten-4">사업자등록증</v-card-subtitle>
                            <v-divider />
                            <image-input v-model="user.businessRegistration" contain flat tile :aspect-ratio="3 / 2" />
                            <v-divider />
                        </template>
                        <template v-if="user.type == PERSON.value">
                            <v-card-subtitle class="font-weight-bold grey lighten-4">프로필</v-card-subtitle>
                            <v-divider />
                            <image-input v-model="user.profile" contain flat tile :aspect-ratio="1 / 1" />
                            <v-divider />
                        </template>
                        <v-card-subtitle class="font-weight-bold grey lighten-4">관리자메모</v-card-subtitle>
                        <v-divider />
                        <v-card-text>
                            <v-textarea v-model="user.note" hide-details auto-grow class="pa-0 ma-0" />
                        </v-card-text>
                    </v-col>
                </v-row>
                <v-divider />

                <v-card-actions class="align-center grey lighten-4">
                    <v-switch v-model="user.isWarning" color="red lighten-1" dense inset hide-details class="my-0 mx-4 pa-0">
                        <span slot="label" class="subtitle-2 font-weight-bold"> 주의회원 </span>
                    </v-switch>
                    <v-switch v-model="user.isApproved" color="red lighten-1" dense inset hide-details class="my-0 mx-4 pa-0">
                        <span slot="label" class="subtitle-2 font-weight-bold"> 회원승인 </span>
                    </v-switch>

                    <v-spacer />
                    <v-btn color="primary" @click="save">저장</v-btn>
                    <user-withdraw v-model="user" @input="$router.go(-1)">
                        <template #activator="{ attrs, on }">
                            <v-btn color="red darken-1" dark class="ml-2" v-bind="attrs" v-on="on">탈퇴</v-btn>
                        </template>
                    </user-withdraw>
                </v-card-actions>
            </v-card>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto"> </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import UserWithdraw from "@/components/console/user/user-withdraw.vue";

import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { USER_FILE_TYPES, USER_TYPES, USER_SCOPE_TYPES } from "@/assets/variables";
import ImageInput from "@/components/console/dumb/image-input.vue";
import VAddressField from "@/components/dumb/v-address-field.vue";

const { COMPANY, PERSON } = USER_TYPES;
const headers_notify = [
    { text: "연락처", value: "contact" },
    { text: "수신동의", value: "enabled", formatter: (value) => (value ? "동의" : "미동의") },
];

export default {
    components: {
        DaumPostcode,
        UserWithdraw,
        ImageInput,
        VAddressField,
    },
    props: {
        _user: { type: String, default: null },
    },
    data: () => ({
        levels: [],
        user: {},

        PERSON,
        COMPANY,
        headers_notify,
    }),
    computed:{
        scope(){
            return Object.values(USER_SCOPE_TYPES).map((scope)=>scope.value)
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            if (this._user) {
                var { user } = await api.console.users.get({ _id: this.$route.params._user });
                if (user?.bornAt) user.bornAt = user.bornAt.toDate();
                if (user?.foundAt) user.foundAt = user.foundAt.toDate();
                this.user = user;
            }

            var { levels } = await api.console.levels.gets();
            this.levels = levels;
        },

        validate() {
            try {
                // if(!this.user.name) throw new Error("담당자 이름을 입력해주세요");
                // if(!this.user.email) throw new Error("담당자 이메일을 입력해주세요");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                let { _businessRegistration, _logo, _profile, businessRegistration, logo, profile, ...item } = this.user;

                ////////////////////////////////////////////////////////////////////////
                // POST, PUT document
                ////////////////////////////////////////////////////////////////////////
                if (!item.password) delete item.password;
                else item.password = CryptoAES.encrypt(item.password);
                const { post, put } = api.console.users;
                const { user } = await (this.user?._id ? put : post)(item);
                ////////////////////////////////////////////////////////////////////////

                ////////////////////////////////////////////////////////////////////////
                // DELETE / POST resources
                ////////////////////////////////////////////////////////////////////////
                // - POST API에서 '기존 resource 삭제' 및 '연관 document 참조'까지 진행
                // - 추가작업 시 로직 일관성을 위해 POST API에서 위 작업 진행
                ////////////////////////////////////////////////////////////////////////
                const { _id: _user } = user;
                if (businessRegistration instanceof File) {
                    businessRegistration = (await api.console.users.files.post({ _user, type: USER_FILE_TYPES.BUSINESS_REGISTRATION.value }, businessRegistration))?.file;
                } else if (_businessRegistration && !businessRegistration) {
                    await api.console.users.files.delete({ _user, _id: _businessRegistration });
                }

                if (logo instanceof File) {
                    logo = (await api.console.users.files.post({ _user, type: USER_FILE_TYPES.LOGO.value }, logo))?.file;
                } else if (_logo && !logo) {
                    await api.console.users.files.delete({ _user, _id: _logo });
                }

                if (profile instanceof File) {
                    profile = (await api.console.users.files.post({ _user, type: USER_FILE_TYPES.PROFILE.value }, profile))?.file;
                } else if (_profile && !profile) {
                    await api.console.users.files.delete({ _user, _id: _profile });
                }

                alert("저장되었습니다");
                this.$router.push(`/console/users`);
            }
        },

        setAddress({ postcode, address }) {
            this.user.postcode = postcode;
            this.user.address1 = address;
        },
    },
};
</script>
